import { NotificationsTranslations } from '../en-US/notifications.translations';

export const notificationsTranslations: NotificationsTranslations = {
  title: 'Meldingen',
  pageTitle: 'Meldingen',
  pageDescription: 'Bekijk en beheer je meldingen',
  settingsTitle: 'Meldingsinstellingen',
  settingsPageTitle: 'Meldingsinstellingen',
  settingsPageDescription: 'Beheer je meldingsvoorkeuren',
  settings: 'Instellingen',
  markAsRead: 'Markeer als gelezen',
  markAllAsRead: 'Markeer alles als gelezen',
  delete: 'Verwijderen',
  more: 'meer',
  noNotifications: 'Geen meldingen',
  emptyDescription: 'Je hebt nog geen meldingen',
  errorLoading: 'Fout bij het laden van meldingen',
  errorLoadingSettings: 'Fout bij het laden van meldingsinstellingen',
  tryAgain: 'Probeer het later opnieuw',
  enableNotifications: 'Meldingen inschakelen',
  enablePromptMessage: 'Blijf op de hoogte van de laatste recensies, likes en volgers door meldingen in te schakelen.',
  remindLater: 'Herinner me later',
  enable: 'Inschakelen',
  stayUpdated: 'Blijf op de hoogte',
  enableDescription: 'Schakel meldingen in om op de hoogte te blijven van nieuwe recensies, likes en volgers.',
  pushNotifications: 'Push-meldingen',
  pushDescription: 'Ontvang meldingen op je apparaat',
  emailNotifications: 'E-mailmeldingen',
  emailDescription: 'Ontvang meldingen via e-mail',
  enableAllNotifications: 'Alle meldingen inschakelen',
  masterToggleDescription: 'Alle meldingen aan/uit zetten',
  notificationTypes: 'Soorten meldingen',
  types: {
    reviewLiked: 'Recensie geliked',
    reviewLikedDescription: 'Ontvang een melding wanneer iemand je recensie liked',
    newPlaceReviews: 'Nieuwe locatierecensies',
    newPlaceReviewsDescription: 'Ontvang een melding wanneer een nieuwe locatie wordt beoordeeld',
    newFoodReviews: 'Nieuwe voedselrecensies',
    newFoodReviewsDescription: 'Ontvang een melding wanneer nieuw voedsel wordt beoordeeld',
    newReviewCreated: 'Nieuwe recensie gemaakt',
    newReviewCreatedDescription: 'Ontvang een melding wanneer een nieuwe recensie wordt gemaakt',
    userFollowed: 'Gebruiker gevolgd',
    userFollowedDescription: 'Ontvang een melding wanneer een gebruiker je volgt',
  },
}; 

export default notificationsTranslations;
